import { render, staticRenderFns } from "./AddAttachmentModal.vue?vue&type=template&id=d004a828&scoped=true"
import script from "./AddAttachmentModal.vue?vue&type=script&lang=js"
export * from "./AddAttachmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d004a828",
  null
  
)

export default component.exports